/**
     * @desc 查询首页HotBids
用于首页HotBids
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {
  /** 总数 */
  count;
  /** 页大小 */
  pageSize;
}

export const init = new defs.Result();

export function request(params, options = {}) {
  return ajax.post('/trading/getHotBids', params);
}

export function upload(params, options = {}) {
  return ajax.upload('/trading/getHotBids', params);
}
